<template>
  <div class="auto-refresh-wrapper">
    <label class="auto-refresh-label">Auto-refresh:</label>
    <div class="grafana-refresh">
      <select :value="modelValue" @change="onChange">
        <option :value="0">⟳ Off</option>
        <option :value="5000">⟳ 5s</option>
        <option :value="10000">⟳ 10s</option>
        <option :value="30000">⟳ 30s</option>
        <option :value="60000">⟳ 1m</option>
        <option :value="300000">⟳ 5m</option>
        <option :value="900000">⟳ 15m</option>
        <option :value="1800000">⟳ 30m</option>
        <option :value="3600000">⟳ 1h</option>
        <option :value="7200000">⟳ 2h</option>
        <option :value="86400000">⟳ 1d</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoRefresh',
  props: {
    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue', 'refresh'],
  data() {
    return {
      intervalId: null
    };
  },
  watch: {
    modelValue: {
      handler() {
        this.syncInterval();
      },
      immediate: true
    }
  },
  beforeUnmount() {
    this.stopInterval();
  },
  methods: {
    onChange(e) {
      const val = Number(e.target.value);
      this.$emit('update:modelValue', val);
    },
    syncInterval() {
      this.stopInterval();
      if (this.modelValue > 0) {
        this.intervalId = setInterval(() => {
          this.$emit('refresh');
        }, this.modelValue);
      }
    },
    stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }
};
</script>

<style scoped>
.auto-refresh-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.auto-refresh-label {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.grafana-refresh select {
  color: #000;
  border-radius: 4px;
  padding: 0 28px 0 10px;
  font-size: 12px;
  height: 32px;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  transition: border-color 0.15s;
  background-color: #fff;
  border: 1px solid #ccc;
}

.grafana-refresh select:focus {
  border-color: #4e54c8;
  box-shadow: none;
}

.grafana-refresh select:hover {
  border-color: #000;
}

.grafana-refresh select option {
  background-color: #1f1f23;
  color: #000;
}
</style>
